var _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCookieAndPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 158,
    viewBox: "0 0 160 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M119.971 25.6909C119.971 25.6909 95.8829 43.9697 59.2634 9.79131C26.7415 -20.5623 0.187241 27.3289 0.00132751 50.2629C-0.239853 79.9722 32.5232 103.743 16.6236 123.256C0.724045 142.77 48.1547 174.992 73.7175 147.106C105.517 112.416 114.132 140.601 132.257 140.601C145.265 140.601 171.974 108.278 153.938 84.2302C138.761 63.9944 147.038 57.2784 151.047 50.2629C156.829 40.1451 143.097 12.6822 119.971 25.6909Z",
    fill: "#26303E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 59.0206,
    r: 11.5,
    fill: "#999999"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 98.0206,
    r: 11.5,
    fill: "#999999"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 91.0206,
    r: 11.5,
    fill: "#999999"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 59.0206,
    r: 11.5,
    fill: "#999999"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 59.0206,
    r: 11.5,
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7035 114.048L46.7774 128.647C50.8022 132.546 55.9268 135.046 61.4514 135.821L82.3389 137.756L61.591 134.831L61.5903 134.831C56.2755 134.085 51.3459 131.681 47.4733 127.928L47.4731 127.928L32.3994 113.329M31.7035 114.048L32.3994 113.329M31.7035 114.048C27.6788 110.148 25.004 105.098 24.029 99.5736M31.7035 114.048L24.029 99.5736M32.3994 113.329C28.5265 109.577 25.9524 104.718 25.0139 99.4003M32.3994 113.329L25.0139 99.4003M25.0139 99.4003C25.0139 99.4002 25.0138 99.4 25.0138 99.3998L21.3893 78.7025L21.3889 78.7005C20.451 73.4094 21.2207 67.9243 23.578 63.0894L23.5787 63.0879L32.7523 44.1907C32.7525 44.1904 32.7527 44.19 32.7529 44.1896C35.1105 39.3545 38.9353 35.386 43.673 32.8608L43.6736 32.8605L62.1699 22.9874C62.1703 22.9872 62.1708 22.987 62.1712 22.9867C66.9347 20.461 72.3448 19.4996 77.6572 20.2439C78.4269 20.3594 79.066 20.9314 79.3076 21.7071L79.3619 22.0573C81.5531 36.1843 92.6622 47.3464 106.741 49.5897L106.744 49.5902C108.261 49.8267 109.492 50.9718 109.85 52.481C112.867 65.4475 123.511 75.4737 136.789 77.5878L136.797 77.589C137.731 77.7299 138.463 78.4279 138.61 79.2924L138.611 79.2996C139.549 84.5907 138.78 90.0757 136.422 94.9106L136.422 94.9117L127.247 113.785L127.247 113.786C124.889 118.646 121.065 122.614 116.327 125.139L116.327 125.14L97.8303 135.013C93.0655 137.539 87.6535 138.501 82.3396 137.756L25.0139 99.4003ZM24.029 99.5736L20.4043 78.875C19.4293 73.3754 20.2293 67.6758 22.6791 62.6512L31.8535 43.7525L24.029 99.5736ZM59.0015 59.0014C59.0015 63.9784 63.024 68.0009 68.001 68.0009C72.9779 68.0009 77.0004 63.9784 77.0004 59.0014C77.0004 54.0244 72.9779 50.002 68.001 50.002C63.024 50.002 59.0015 54.0244 59.0015 59.0014ZM60.0015 107.998C64.9785 107.998 69.001 103.976 69.001 98.9986C69.001 94.0217 64.9785 89.9992 60.0015 89.9992C55.0245 89.9992 51.0021 94.0217 51.0021 98.9986C51.0021 103.976 55.0245 107.998 60.0015 107.998ZM98.9987 90.9992C98.9987 95.9762 103.021 99.9986 107.998 99.9986C112.975 99.9986 116.998 95.9762 116.998 90.9992C116.998 86.0222 112.975 81.9997 107.998 81.9997C103.021 81.9997 98.9987 86.0222 98.9987 90.9992Z",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 120.021,
    r: 3.5,
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookieAndPrivacy);
export default __webpack_public_path__ + "static/media/cookieAndPrivacy.f0281af8.svg";
export { ForwardRef as ReactComponent };